import React from 'react'
import clsx from 'clsx'
import {
  SOCIAL_REACTION_ASSETS,
  SOCIAL_REACTION_EMOJIS,
  type SocialReactionEmoji,
} from '../../../types/social'

export function normalizeReactionEmoji(emoji: string): string {
  return emoji === '❤️' ? '💚' : emoji
}

export function getReactionAsset(emoji: string) {
  const key = normalizeReactionEmoji(emoji) as SocialReactionEmoji
  return SOCIAL_REACTION_ASSETS[key]
}

export function getReactionLabel(emoji: string): string {
  return getReactionAsset(emoji)?.label ?? emoji
}

const sizeClass = {
  xs: 'h-4 w-4',
  sm: 'h-5 w-5',
  md: 'h-6 w-6',
  lg: 'h-7 w-7',
  xl: 'h-10 w-10',
} as const

export interface ReactionEmojiIconProps {
  emoji: string
  size?: keyof typeof sizeClass
  className?: string
}

export const ReactionEmojiIcon: React.FC<ReactionEmojiIconProps> = ({
  emoji,
  size = 'sm',
  className,
}) => {
  const asset = getReactionAsset(emoji)

  if (asset) {
    return (
      <img
        src={asset.src}
        alt={asset.label}
        className={clsx(sizeClass[size], 'object-contain shrink-0', className)}
        draggable={false}
      />
    )
  }

  return (
    <span className={clsx('inline-flex items-center justify-center leading-none', className)}>
      {emoji}
    </span>
  )
}

export function isKnownReactionEmoji(emoji: string): emoji is SocialReactionEmoji {
  return SOCIAL_REACTION_EMOJIS.includes(normalizeReactionEmoji(emoji) as SocialReactionEmoji)
}
